import { useTranslation } from 'react-i18next'

export const useTourHomePage = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-wrapper-destination',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.welcomeMessage')}</p>
          <span>{t('tour.destinationDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-salepoint',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.salePoint')}</p>
          <span>{t('tour.salePointDescription')} </span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-date',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.checkInOut')}</p>
          <span>{t('tour.checkInOutDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-more-filters',
      content: (
        <div>
          <p className="text-primary font-bold">+{t('tour.filters')}</p>
          <span>{t('tour.filtersDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-clean-filters',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.cleanFilters')}</p>
          <span>{t('tour.cleanFiltersDescription')}</span>
        </div>
      ),
    },

    {
      selector: '.joyride-wrapper-more-fields',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.additionalFilters')}
          </p>
          <span>{t('tour.additionalFilterDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-map',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.viewMap')}</p>
          <span>{t('tour.mapDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-wrapper-SearchButton',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.Search')}</p>
          <span>{t('tour.SearchDescription')}</span>
        </div>
      ),
    },
  ]
}
